import { useState, useEffect, useCallback } from 'react';

const TestimonialSlideshow = () => {
  const slides = [
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/b1264001500e62f7b54daa511b2966c7.png",
      alt: "Client review - passed audit with manuals up to date"
    },
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/4508d3eae21778fe8b955ebdda98fdd3.png",
      alt: "Client review - comprehensive program, saved a lot"
    },
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/126ad9117c7d0b402f24b93e453dab31.png",
      alt: "Client review - services and knowledge important to growing company"
    },
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/940e4248b0319fb627ece7a127d06618.png",
      alt: "LinkedIn recommendation - Michael Securo, EVP at Semper Home Loans"
    },
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/f851dbebcf9327daaf32d4736583d83c.png",
      alt: "Facebook review - Brett Zaroff, long-time client highly recommends Mortgagemanuals.com"
    },
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/c2e6c69b35bf1aab1f62c240bebca29d.png",
      alt: "Client review - Got approved, need to discuss getting things in better shape"
    },
    {
      image: "https://static.readdy.ai/image/807f7a13fa3a4707437af02957aa93c9/8df83a2948f9852bd4afead853eb375e.png",
      alt: "Client review - Risk Assessment accepted by NY State Mortgage Department"
    }
  ];

  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prev = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <div className="relative w-full max-w-3xl mx-auto">
      {/* Slide */}
      <div className="relative overflow-hidden rounded-2xl shadow-xl bg-white border border-gray-100">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="min-w-full">
              <img
                src={slide.image}
                alt={slide.alt}
                className="w-full h-auto object-contain max-h-80"
              />
            </div>
          ))}
        </div>

        {/* Prev / Next */}
        <button
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-md cursor-pointer transition-all"
          aria-label="Previous review"
        >
          <i className="ri-arrow-left-s-line text-gray-700 text-xl"></i>
        </button>
        <button
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-md cursor-pointer transition-all"
          aria-label="Next review"
        >
          <i className="ri-arrow-right-s-line text-gray-700 text-xl"></i>
        </button>
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-4">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
              index === current ? 'bg-red-600 w-6' : 'bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Go to review ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

const TrustSection = () => {
  const stats = [
    { number: "500+", label: "Financial Firms Protected", icon: "ri-building-line" },
    { number: "99.7%", label: "Threats Blocked", icon: "ri-shield-check-line" },
    { number: "24hrs", label: "Average Setup Time", icon: "ri-time-line" },
    { number: "$2.4M", label: "Average Breach Cost Prevented", icon: "ri-money-dollar-circle-line" }
  ];

  const certifications = [
    { name: "SOC 2 Type II", icon: "ri-award-line" },
    { name: "ISO 27001", icon: "ri-medal-line" },
    { name: "NIST Compliant", icon: "ri-shield-star-line" },
    { name: "FFIEC Approved", icon: "ri-government-line" }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-red-600`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-sm text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials Slideshow */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">
            What Our Clients Say
          </h2>
          <TestimonialSlideshow />
        </div>

        {/* Certifications */}
        <div className="text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-8">
            Trusted & Certified
          </h3>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {certifications.map((cert, index) => (
              <div key={index} className="flex items-center gap-3 bg-white px-6 py-3 rounded-lg shadow">
                <i className={`${cert.icon} text-xl text-red-600`}></i>
                <span className="font-semibold text-gray-700">{cert.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
